import { render, staticRenderFns } from "@/modules/Ticket/templates/ticket-detail.html?vue&type=template&id=219bf02b&scoped=true&"
import script from "@/modules/Ticket/scripts/ticket-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Ticket/scripts/ticket-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Ticket/styles/ticket-detail.scss?vue&type=style&index=0&id=219bf02b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219bf02b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
